import type { StickerColor } from "./StickerType";
import type { BoardType, InfoLevel, StatusClass } from "./baseTypes";
import color from "./color.module.scss";

export const linkColors: Record<InfoLevel, string> = {
  default: color.textSecondary,
  ok: color.ok,
  warn: color.altWarn,
  error: color.altError,
};

export const stickerColors: Record<StickerColor, string> = {
  red: color.stickerRed,
  orange: color.stickerOrange,
  yellow: color.stickerYellow,
  blue: color.stickerBlue,
  purple: color.stickerPurple,
  green: color.stickerGreen,
};

export type LinkBoardType = Extract<BoardType, "program" | "risk" | "team" | "flex">;

export const normalLinkColors: Record<LinkBoardType, string> = {
  program: color.link2,
  risk: color.link1,
  team: color.link1,
  flex: color.link1,
};

// Default persistent-link color per board (linkColor() in linkLayer.ts
// overrides for risky/ready-dep state).
export function normalLinkColorForBoard(type: BoardType): string {
  switch (type) {
    case "solution":
    case "program":
      return normalLinkColors.program;
    case "risk":
      return normalLinkColors.risk;
    case "flex":
      return normalLinkColors.flex;
    default:
      return normalLinkColors.team;
  }
}

export const statusClassColors: Record<StatusClass, string> = {
  undefined: color.statusClassUndefined,
  todo: color.statusClassTodo,
  "in-progress": color.statusClassProgress,
  done: color.statusClassDone,
};
